"use client";

import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";

/**
 * 检测当前环境是否是在原生App内部
 * 主要通过URL参数检测 (channelSource=app)
 *
 * @returns {boolean} 是否是原生App环境
 */
export function useIsNativeApp() {
  const $ = _c(3);
  const [isNativeApp, setIsNativeApp] = useState(false);
  const searchParams = useSearchParams();
  let t0;
  let t1;
  if ($[0] !== searchParams) {
    t0 = () => {
      const isFromAppParam = searchParams.get("channelSource") === "app";
      setIsNativeApp(isFromAppParam);
    };
    t1 = [searchParams];
    $[0] = searchParams;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return isNativeApp;
}
export default useIsNativeApp;